export default __webpack_public_path__ + "static/media/2015-JN.a5dda8c3.jpg";